module.exports = __webpack_public_path__ + "static/img/new_bussiness_img2.8042ec5.png";